import { useTranslation } from "react-i18next";
import { Download, FileSpreadsheet } from "lucide-react";
import { reportUrl } from "@/lib/api";

const REPORTS = [
  { file: "farmers.csv", key: "farmers" },
  { file: "orchards.csv", key: "orchards" },
  { file: "fpos.csv", key: "fpos" },
  { file: "buyers.csv", key: "buyers" },
  { file: "procurement.csv", key: "procurement" },
  { file: "seasonal/orchard.csv", key: "seasonal_orchards" },
  { file: "seasonal/farmer.csv", key: "seasonal_farmers" },
];

export default function AdminReports() {
  const { t } = useTranslation();
  const token = localStorage.getItem("trueroots.jwt");
  const download = async (file) => {
    const url = reportUrl(file);
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) return;
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = file.replace("/", "_");
    a.click();
    URL.revokeObjectURL(a.href);
  };

  return (
    <div data-testid="admin-reports">
      <div className="flex items-center gap-3 mb-2">
        <FileSpreadsheet className="w-6 h-6 text-[var(--tr-deep-green)]" />
        <h2 className="tr-section-title text-3xl">{t("reports.title")}</h2>
      </div>
      <p className="text-[var(--tr-muted)] leading-relaxed max-w-3xl">{t("reports.body")}</p>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="reports-grid">
        {REPORTS.map((r) => (
          <button key={r.file} data-testid={`report-${r.key}`} onClick={() => download(r.file)} className="tr-card p-6 text-left hover:-translate-y-1 transition-transform">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-display font-extrabold text-lg text-[var(--tr-deep-green)]">{t(`reports.${r.key}`)}</div>
                <div className="text-xs text-[var(--tr-muted)] mt-1 font-mono">{r.file}</div>
              </div>
              <Download className="w-6 h-6 text-[var(--tr-deep-green)]" />
            </div>
            <div className="mt-4 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-[0.14em] text-[var(--tr-zest)]">{t("reports.download_csv")}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
